import { useStore } from '@nanostores/react'
import { atom } from 'nanostores'

export const enum Mode {
	None,
	Contacts,
	Executions
}

export const $modalMode = atom<Mode>(Mode.None)
export const closeFilter = () => $modalMode.set(Mode.None)
export const useMode = () => useStore($modalMode)
